<template>
  <Form :d_user="user" :d_negeri="negeri"/>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_Form.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
   props: {
        // user: Object,
        user: [Array, Object],
        items: [Array, Object],
        // id: [Array, Object, String],
    },
  data() {
    return {

        files: [],
        attahecment : [], 
        country : [],
        user: this.user,
        bandar : [],
        negeri : [],
        poskod : [],
        negara : [],
        peran : [],
        jenis_pengguna : [],
        cawangan: [],
       
     
    }
  },
  methods: {

        getPeranan(id){
            this.$zcomm.get(this.api_service + 'lookup/peranan/'+this.form.lkp_jenis_pengguna_id, {}).then(res => {
              this.peran = res
            })
        },

        getlkpJenisPengguna(){
            this.$zcomm.get(this.api_service + 'lookup/jenis_pengguna', {}).then(res => {
              this.jenis_pengguna = res
            })
        },

         getCawangan(id){
            if(id==2||this.user.lkp_negeri_id==null||this.user.lkp_negeri_id==''){
               alert('sdf');
               this.user.lkp_bandar_id = null;
               this.user.lkp_poskod_id = null;
               this.user.lkp_cawangan_id = null;
               this.form.alamat = null;
            }
            this.$zcomm.get(this.api_service + 'lookup/cawangan/'+this.user.lkp_negeri_id, {}).then(res => {
              this.cawangan = res
              this.getPoskodNegri(1);
            })
         },
         getPoskodNegri(id){
           this.$zcomm.get(this.api_service + 'lookup/poskod_negeri/'+this.user.lkp_negeri_id, {}).then(res => {
             this.poskod = res
           })
         },
         getAlamat(){
            this.$zcomm.get(this.api_service + 'lookup/alamat/'+this.user.lkp_cawangan_id, {}).then(res => {
              this.user.alamat = res.alamat
              this.user.lkp_bandar_id = res.lkp_bandar_id
              this.user.lkp_poskod_id = res.lkp_poskod_id
               this.getBandar();
               this.getPoskod()
              // if (this.alamat.length > 0) {
              //  this.form.alamat = this.alamat.alamat;
              // }
            })
         },
         getNegara(){
            this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
              this.negara = res
            })
         },
        
        getNegeri(){
          this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
            this.negeri = res
          })
        },

        getBandar(item){
            if (item == 2) {
              this.user.lkp_poskod_id = '';
              this.user.lkp_bandar_id = '';
            }
            if(item == 2 || (item == 1 && this.user.lkp_bandar_id != '')){
              this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.user.lkp_negeri_id, {}).then(res => {
              this.bandar = res
              })
            }
        },

         getPoskod(id){
            this.$zcomm.get(this.api_service + 'lookup/poskod/'+this.user.lkp_bandar_id, {}).then(res => {
              this.poskod = res
            })
         },
         getBandarPoskod(id){
            this.user.lkp_bandar_id = '';
            this.$zcomm.get(this.api_service + 'lookup/bandar_poskod/'+this.user.lkp_poskod_id, {}).then(res => {
               this.bandar = res
            })
         },

        getPoskodUtama(){
            this.$zcomm.get(this.api_service + 'lookup/poskod_utama/'+this.form.kode, {}).then(res => {
              // this.form.p = res.p
              this.form.lkp_negeri_id = res.lkp_negeri_id
              this.form.lkp_bandar_id = res.lkp_bandar_id
              this.form.lkp_poskod_id = res.lkp_poskod_id
              this.getPoskod(0)
              this.getBandar(0)
            })
        },

        checkPoskod(){
          // alert(this.form.lkp_poskod_id);
          if(this.form.lkp_poskod_id == null){
            this.form.p = 0
          }
        },
        simpan() {
            this.$zcomm.post('profile-update',this.user).then(res => {
                console.log(res);
                this.$zutil.notify("Berjaya disimpan");
                this.$inertia.visit(this.$route('home'));
                  
                })
                 .catch(err => {
                })
        },
        uploadImg(item) 
        {  
           let formData = new FormData();
           for (var b in this.files) 
           {
               formData.append("files["+b+"]", this.files[b].file);
           }
           formData.append("model",item);
           formData.append("model_id", this.user.id);
           this.$zcomm.post('attahecment.upload_replace', formData)
               .then((res) => {
                    this.$inertia.visit(
                        window.route("profile", this.user.id),
                    );
                   
                    // this.$inertia.reload();
               })
               .catch((err) => {})
               .finally(() => {});
        },
       
        
       
    
  },

  

  watch: {

  },
  mounted() {
    this.getNegeri();
    // this.getBandar(1);
    // this.getPoskod(1);
    // this.getNegara();
    // this.getlkpJenisPengguna();
    // this.getCawangan(1)
    this.dialog.width = 500
      
  },
}
</script>
